/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userList.config.json";
import axios from "axios";
export interface IUserListMethodsMethods extends IPluginMethodMap {
  getUserListProps(args: any): Promise<any>;
}

export class UserListService implements IAgentPlugin {
  readonly methods: IUserListMethodsMethods;

  constructor() {
    this.methods = {
      getUserListProps: this.getUserListProps.bind(this),
    };
  }

  async getUserListProps(args: any) {
    try {
      const res = await axios.post(config.url);
      if (res?.data) {
        let _tempUsers = res?.data?.data.map((item: any) => {
          return {
            value: item.email,
            label: `${item?.name} (${item?.email})`,
          };
        });
        let _formData = config?.userSelectFields.map((item) => {
          return {
            ...item,
            fieldProps: {
              ...item?.fieldProps,
              initialOptions: _tempUsers,
            },
          };
        });
        return {
          userFields: config.userFields,
          userSelectFields: _formData,
        };
      }
    } catch (err: any) {}
    return { ...(config || {}) };
  }
}
